import { render, staticRenderFns } from "./EnterMarksSheet.vue?vue&type=template&id=86032d0a&scoped=true"
import script from "./EnterMarksSheet.vue?vue&type=script&lang=js"
export * from "./EnterMarksSheet.vue?vue&type=script&lang=js"
import style0 from "./EnterMarksSheet.vue?vue&type=style&index=0&id=86032d0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86032d0a",
  null
  
)

export default component.exports